<template>
  <div>
    <h1>Qui andrà messa la guida</h1>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alertType: null,
      message: null,
      isLoading: null
    };
  },
  created() {},
  methods: {}
};
</script>